var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bulk_2_User",
    "data-name": "Iconly/Bulk/2 User",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.346,
    height: 14.711,
    viewBox: "0 0 16.346 14.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2_User",
    "data-name": "2 User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M1088.006,879.357c-3.24,0-6.007.5-6.007,2.5s2.75,2.519,6.007,2.519c3.24,0,6.007-.5,6.007-2.5S1091.264,879.357,1088.006,879.357Z",
    transform: "translate(-1082 -869.667)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Fill_3",
    "data-name": "Fill 3",
    cx: 3.972,
    cy: 3.89,
    rx: 3.972,
    ry: 3.89,
    transform: "translate(2.035)",
    fill: "#cea95a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    d: "M1095.942,871.608a5.2,5.2,0,0,1-.929,2.98.145.145,0,0,0,.1.225,3.243,3.243,0,0,0,.457.042,3.282,3.282,0,1,0,.094-6.56,3.386,3.386,0,0,0-.668.067.122.122,0,0,0-.078.045.091.091,0,0,0,.015.1A5.241,5.241,0,0,1,1095.942,871.608Z",
    transform: "translate(-1084.358 -867.645)",
    fill: "#cea95a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M1100.638,879.342a2.607,2.607,0,0,0-2.012-1.2,14.992,14.992,0,0,0-3.063-.261.035.035,0,0,0-.03.023.044.044,0,0,0,.027.045,4.09,4.09,0,0,1,2.507,4.027.169.169,0,0,0,.191.19c.545-.076,1.946-.371,2.38-1.289A1.722,1.722,0,0,0,1100.638,879.342Z",
    transform: "translate(-1084.472 -869.397)",
    fill: "#cea95a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.f3b5f6bc4197ec2cbaecc2315196c55e.svg";
export { ForwardRef as ReactComponent };